module.exports = __webpack_public_path__ + "static/pets-section-bg-decor-63cac063a841468bb7a5524b3ea00f0d.png";